import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import dataServices from "../../apiServices/data.services";
import Loader from "../../components/Loader/Loader";
import { useAlert } from "react-alert";
import { handleValidationError } from "../../components/CommonFunctions";

const SubscriptionDetails = () => {
  const { id } = useParams();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const alert = useAlert();

  useEffect(() => {
    dataServices
      .getSubscriptionDetails(id)
      .then((res) => {
        if (res.status === 200) {
          setSubscription(res.data);
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => setLoading(false));
  }, [id, alert]);

  if (loading) return <Loader />;
  if (!subscription) return <div className="content-wrapper"><p className="px-3">Subscription not found.</p></div>;

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 fw-bold text-black">Subscription Details</h6>
        <button className="btn btn-sm btn-secondary" onClick={() => navigate("/subscriptions")}>Back</button>
      </div>
      <div className="card p-3">
        <p><strong>ID:</strong> {subscription.id}</p>
        <p><strong>Plan:</strong> {subscription.plan?.name || subscription.plan_name || "N/A"}</p>
        <p><strong>Start Date:</strong> {subscription.start_date || "N/A"}</p>
        <p><strong>End Date:</strong> {subscription.end_date || "N/A"}</p>
        <p><strong>Status:</strong> {subscription.status || "N/A"}</p>
        <p><strong>Description:</strong> {subscription.description || "No description"}</p>
      </div>
    </div>
  );
};

export default SubscriptionDetails;
